
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/signup/category",
      function () {
        return require("private-next-pages/signup/category.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/signup/category"])
      });
    }
  